import React, { useState } from 'react';

import { isNil } from 'ramda';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormTitle from 'components/shared/Typography/FormTitle';
import { accountIdSelector } from 'store/user/selectors';
import api from 'utils/axios';
import { debounce } from 'utils/debounce';

import { formatOwnerLabel } from '../functions';

function AssignOwner({ account }) {
  const accountId = useSelector(accountIdSelector);
  const initialOptions =
    isNil(account) || account.id === accountId ? [] : [{ value: account.id, label: formatOwnerLabel(account) }];
  const [options, setOptions] = useState(initialOptions);

  const loadOptions = debounce(async (q, cb) => {
    const data = await api
      .get(`/acc/${accountId}/accounts`, { params: { q, types: ['owner'], countless: '1', active: true } })
      .then(({ data }) => data.data);

    const options = data.map((account) => ({ value: account.id, label: formatOwnerLabel(account) }));
    cb(options);
    setOptions(options);
  }, 1000);

  return (
    <>
      <FormTitle hint="Assign a new owner to this content page below.">VI. Assign Owner</FormTitle>

      <Field
        component={FormGroupAdapter}
        name="accountId"
        placeholder="Please enter company, name or email here"
        type="asyncSelect"
        label="Owner"
        options={options}
        loadOptions={loadOptions}
        noOptionsMessage={() => null}
      />
    </>
  );
}

export default React.memo(AssignOwner);
